const modules = import.meta.glob<{ default: string }>('./nechanice-*.jpg', { eager: true });

export const nechaniceImages = Object.keys(modules)
  .sort((a, b) => {
    const na = parseInt(a.match(/nechanice-(\d+)/)?.[1] || '0');
    const nb = parseInt(b.match(/nechanice-(\d+)/)?.[1] || '0');
    return na - nb;
  })
  .map(k => modules[k].default);

import fp1np3d from './fp-1np-3d.jpg';

export const nechaniceFloorPlans = [
  { image: fp1np3d, label: "1. NP – 3D" },
];
